import React from 'react';
import { HeroCarousel } from '../components/home/HeroCarousel';
import { CompanyIntro } from '../components/home/CompanyIntro';
import { ServicesPreview } from '../components/home/ServicesPreview';
import { WhyLiftoff } from '../components/home/WhyLiftoff';
import { LatestProjects } from '../components/home/LatestProjects';
import { EquipmentPreview } from '../components/home/EquipmentPreview';
import { CapabilityLinks } from '../components/home/CapabilityLinks';
import { QualityOverview } from '../components/home/QualityOverview';
import { QuoteBanner } from '../components/ui/QuoteBanner';
import { useSeo } from '../hooks/useSeo';
import { pageMeta } from '../data/seo';
import { organizationJsonLd } from '../data/structuredData';
export function Home() {
  useSeo(pageMeta.home, organizationJsonLd);
  return <>
      <HeroCarousel data-id="element-708" data-mp="3kuqvf96ejtj3" />
      <CompanyIntro data-id="element-709" data-mp="3kxd1t5hk42zq" />
      <ServicesPreview data-id="element-710" data-mp="3owvpua4ocu6s" />
      <WhyLiftoff data-id="element-711" data-mp="3ow41nkdepyqj" />
      <LatestProjects data-id="element-712" data-mp="3ovkhdx0aay9c" />
      <EquipmentPreview data-id="element-713" data-mp="3oyymve48vnl0" />
      <CapabilityLinks data-id="element-714" data-mp="30wrt0rjcmhkt" />
      <QualityOverview data-id="element-715" data-mp="30x1j0f4e8oqi" />
      <QuoteBanner data-id="element-716" data-mp="30w9kowjewcwj" />
    </>;
}